import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingRateRequirementDataImplEncoder } from "../../encoder/FixingRateRequirementDataImplEncoder";

import * as CubiqTS from "../../index";
import { FixingRateRequirementData } from "../FixingRateRequirementData";

export class FixingRateRequirementDataImpl
  extends ConcreteEncodable
  implements FixingRateRequirementData
{
  public static enType: string = "com.bcdfx.model.FixingRateRequirementDataImpl";

  /*FID=1*/
  public requirementId: CubiqTS.Long | null = null;
  /*FID=2*/
  public createdDts: CubiqTS.moment.Moment | null = null;
  /*FID=3*/
  public baseCurrencyCd: string;
  /*FID=4*/
  public nonBaseCurrencyCd: string;
  /*FID=5*/
  public rateSourceCd: string;
  /*FID=6*/
  public fixingTime: CubiqTS.moment.Moment | null = null;
  /*FID=7*/
  public lockedByUserId: CubiqTS.Long | null = null;
  /*FID=8*/
  public clearedFg: boolean;
  /*FID=9*/
  public traderGroupIds: Array<CubiqTS.Long> | null = null;
  /*FID=10*/
  public commentsTxt: CubiqTS.Errors | null = null;
  /*FID=11*/
  public visibleCcyPairs: Array<string> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingRateRequirementDataImplEncoder.Instance;
    this.setEncodableType(FixingRateRequirementDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FixingRateRequirementDataImpl[" +
      "requirementId=" +
      this.requirementId +
      "createdDts=" +
      this.createdDts +
      "baseCurrencyCd=" +
      this.baseCurrencyCd +
      "nonBaseCurrencyCd=" +
      this.nonBaseCurrencyCd +
      "rateSourceCd=" +
      this.rateSourceCd +
      "fixingTime=" +
      this.fixingTime +
      "lockedByUserId=" +
      this.lockedByUserId +
      "clearedFg=" +
      this.clearedFg +
      "traderGroupIds=" +
      this.traderGroupIds +
      "commentsTxt=" +
      this.commentsTxt +
      "visibleCcyPairs=" +
      this.visibleCcyPairs +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
